import { AxiosResponse } from 'axios';
import { ISettings, SETTINGS } from '../init';
import rmnApi from './rmnApi';

interface IAdsRequestBase {
  search?: string;
  category?: string;
  placements: { placement_id: number }[];
  page_number: number;
  session_id: string;
  customer: { customer_id: string; device_type?: string };
  max_ads?: number;
  products?: Partial<{ id: string; category: string }>[];
}

export interface IInhouseAdsRequest extends IAdsRequestBase {
  account_id: string;
}

export interface IProxyAdsRequest extends IAdsRequestBase {
  marketplace_id: number;
}

export type ISponsoredAdsRequest = IProxyAdsRequest | IInhouseAdsRequest;

/**
 * This function adds either an `account_id` (for 'api' mode) or a `marketplace_id`
 * (for 'proxy' mode) to the provided base parameters. The mode is determined by
 * `SETTINGS.MODE`, defaulting to 'proxy' if not specified.
 */
export function generateAdsRequestBody(
  params: IAdsRequestBase,
): ISponsoredAdsRequest {
  switch (SETTINGS.MODE) {
    case 'api': {
      return {
        account_id: SETTINGS.ACCOUNT_ID,
        ...params,
      };
    }
    case 'proxy':
    default:
      return {
        marketplace_id: SETTINGS.MARKET_PLACE_ID,
        ...params,
      };
  }
}

interface IPaidProduct {
  ad_id: string;
  advertiser_id: string;
  position: number;
  product_id: string;
  campaign_id: number;
  misc: string;
}

interface IBanner {
  ad_id: string;
  advertiser_id: string;
  campaign_id: number;
  creative_id: number;
  img_url: string;
  position: number;
  redirect: { type: string; url: string };
  misc: string;
}

export type IAdItem = IPaidProduct & IBanner;

interface IPlacementItem {
  ads: IAdItem[];
}

export interface ISponsoredAdsResponse {
  placements: IPlacementItem[];
}

const PATH: Record<ISettings['MODE'], string> = {
  api: '/v0/ads',
  proxy: '/v0/proxy/ads',
};

export const apiPostAds = async (
  requestBody: ISponsoredAdsRequest,
): Promise<AxiosResponse<ISponsoredAdsResponse>> => {
  return rmnApi(PATH[SETTINGS.MODE], requestBody);
};
